import { useCallback, useState } from 'react'

import { FeedbackGridApi } from '../api/feedbackGridApi'

interface UseGridExportReturn {
	exporting: boolean
	exportData: () => void
}

export const useGridExport = (api: FeedbackGridApi): UseGridExportReturn => {
	const [exporting, setExporting] = useState(false)

	const exportData = useCallback(() => {
		setExporting(true)
		try {
			api.exportData()
		} finally {
			// Reset after a short delay to show feedback
			setTimeout(() => {
				setExporting(false)
			}, 1000)
		}
	}, [api])

	return {
		exporting,
		exportData,
	}
}
